import { Table } from "antd";
import React from "react";
import { useCollection } from "../../../hooks/useCollection";
import { ColorConsumptionPopup } from "./ColorConsumptionPopup";

export default function ColorConsumption() {
   const { loading, data } = useCollection("krasuPaterins");
   const columns = [
      {
         title: "Type",
         dataIndex: "type",
      },
      {
         title: "Consumption",
         dataIndex: "consumption",
         align: "center",
         sorter: {
            compare: (a, b) => a.consumption - b.consumption,
         },
      },
      {
         render: (value) => <ColorConsumptionPopup title={value.type} consumption={value.consumption} id={value.id} />,
      },
   ];

   const onChange = (pagination, filters, sorter, extra) => {
      console.log("params", pagination, filters, sorter, extra);
   };

   return (
      <div>
         <Table columns={columns} size="small" loading={loading} dataSource={data} onChange={onChange} pagination={false} />
      </div>
   );
}
